import { Layouts } from 'react-grid-layout';
import CustomDownloader from '../../components/FeeReport/CustomDownloader';
import SimpleFilters from '../../components/FeeReport/Filters/SimpleFilters';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 5,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    md: [
        {
            h: 32,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    xs: [
        {
            h: 40,
            static: true,
            w: 24,
            x: 0,
            y: 3,
            i: 'c2',
        },
        {
            h: 3,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {
        date: 'month',
    },
    components: [
        {
            key: 'c1',
            name: 'page-header',
            props: {
                header: {
                    title: '',
                    path: '',
                },
                rhsComponents: [
                    {
                        name: 'page-switcher',
                        props: {
                            text: 'view-reports',
                            path: '/reports/fee-report/view-reports',
                            ga_event_name: 'Fee Report > View Reports',
                        },
                    },
                    {
                        name: 'date-range-picker',
                        props: {
                            defaultPeriod: '1M',
                        },
                    },
                ],
            },
        },
        {
            name: 'canopy-table',
            key: 'c2',
            apiDetails: {
                endpoint: `reports/fee?`,
                endpointVersion: 'v2',
                endpointParams: {
                    per_page: '*,per_page',
                    page: '*,page',
                    keyword: 'keyword',
                    from_date: '*,from_date',
                    to_date: '*,to_date',
                    sort_column: 'sortColumn',
                    sort_direction: 'sortDirection',
                    uploaded_by: 'uploaded_by',
                    username: 'username',
                    parent_username: 'parent-username',
                    child_username: 'child-username',
                },
            },
            props: {
                headerText: 'fee_schedule',
                requiredQueryFields: [],
                dataKey: 'feeCalculationSummary',
                title: '',
                canSelectRows: false,
                CustomTableFilter: <SimpleFilters />,
                CustomDownloader: <CustomDownloader />,
                showDownloadOn: [],
                columns: [
                    {
                        key: 'parentUsername',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.parent-username',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        canSort: true,
                        canReorder: true,
                    },
                    {
                        key: 'childUsername',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.child-username',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        canSort: true,
                        canReorder: true,
                    },
                    {
                        key: 'aumFeeAmount',
                        type: 'amount',
                        headerText: 'ui.mm.fee-schedule.anum-fee',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        canSort: true,
                        canReorder: true,
                    },
                    {
                        key: 'retrocessionFeeAmount',
                        type: 'amount',
                        headerText: 'ui.mm.fee-schedule.retrocession-fee',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        canSort: true,
                        canReorder: true,
                    },
                    {
                        key: 'reportRunAt',
                        type: 'date',
                        headerText: 'ui.mm.fee-schedule.report-run-at',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        canSort: true,
                        canReorder: true,
                    },
                    {
                        key: 'feeCurrency',
                        type: 'text',
                        headerText: 'ui.mm.fee-schedule.fee-currency',
                        canSort: true,
                        canReorder: true,
                    },
                    {
                        key: 'parentDisplayName',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.parent-display-name',
                        canSort: true,
                        canReorder: true,
                    },
                    {
                        key: 'childDisplayName',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.child-display-name',
                        canSort: true,
                        canReorder: true,
                    },
                ],
                per_page: 25,
                defaultSelection: '',
                filterType: 'simple-filters',
                filterApi: 'filters/child-accounts',
                ga_event_name: 'Fee Report',
            },
        },
    ],
};
